module.exports = __webpack_public_path__ + "static/media/iphone2.9c0170c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/iphone2.jpg
// module id = 413
// module chunks = 1